module.exports = __webpack_public_path__ + "static/media/cq_corsivo b.24a86fbd.svg";